// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-option-container-IvP10 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  user-select: none;
  cursor: pointer;
  color: var(--color-neutral-900);
  padding: 12px 4px 12px 12px;
}

.select-option-container-IvP10:hover {
  background-color: var(--hover-color);
}

.select-option-selected-H1pIQ, .select-option-selected-H1pIQ:hover {
  background-color: var(--active-color);
}

.select-option-icon-iDx_r {
  --size: 20px;
  flex-shrink: 0px;
  margin: 0px 8px;
}

.select-option-disabled-ovJfy {
  cursor: default;
}

.select-option-disabled-ovJfy:hover {
  background-color: initial;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/select-option/select-option.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 15px;\n  user-select: none;\n  cursor: pointer;\n  color: var(--color-neutral-900);\n  padding: 12px 4px 12px 12px;\n}\n\n.container:hover {\n  background-color: var(--hover-color);\n}\n\n.selected, .selected:hover {\n  background-color: var(--active-color);\n}\n\n.icon {\n  --size: 20px;\n  flex-shrink: 0px;\n  margin: 0px 8px;\n}\n\n.disabled {\n  cursor: default;\n}\n\n.disabled:hover {\n  background-color: initial;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `select-option-container-IvP10`,
	"selected": `select-option-selected-H1pIQ`,
	"icon": `select-option-icon-iDx_r`,
	"disabled": `select-option-disabled-ovJfy`
};
export default ___CSS_LOADER_EXPORT___;
